import homeVerticalsImg1 from "@/public/pages/home_page/our_verticals/modular.jpg";
import homeVerticalsImg2 from "@/public/pages/home_page/our_verticals/container.jpg";
import homeVerticalsImg3 from "@/public/pages/home_page/our_verticals/pop-up.jpg";
import homeVerticalsImg4 from "@/public/pages/home_page/our_verticals/new-glamping.jpg";
import homeVerticalsImg5 from "@/public/pages/home_page/our_verticals/design.jpg";

import HandWithFlagSvg from "@/common/Svgs/HandWithFlag";
import PlantSvg from "@/common/Svgs/Plant";
import WomanSvg from "@/common/Svgs/Woman";

/* ---------------------------------------------- */
/* ------------- HEADER MAINN LINKS ------------- */
/* ---------------------------------------------- */
export const HEADER_MAIN_LINKS = [
  {
    id: "about",
    label: "About Us",
    href: "/about",
  },
  {
    id: "projects",
    label: "Our Projects",
    href: "/projects",
  },
  {
    id: "build",
    label: "Start Build",
    href: "/config",
  },
  {
    id: "news",
    label: "Our News",
    href: "/news",
  },
  {
    id: "contact",
    label: "Contact Us",
    href: "/contact",
  },
];

/* -------------------------------------------- */
/* ------------- OUR PROJECTS NAV ------------- */
/* -------------------------------------------- */
export const OUR_PRODUCTS = [
  {
    id: "modular",
    name: "Modular",
    slug: "modular",
    media: {
      src: homeVerticalsImg1,
      alt: "verticals image",
    },
    mediaHover: {
      src: homeVerticalsImg5,
      alt: "verticals image",
    },
  },
  {
    id: "container",
    name: "Container",
    slug: "container",
    media: {
      src: homeVerticalsImg2,
      alt: "verticals image",
    },
    mediaHover: {
      src: homeVerticalsImg4,
      alt: "verticals image",
    },
  },
  {
    id: "pop-up",
    name: "Pop-Up",
    slug: "pop-up",
    media: {
      src: homeVerticalsImg3,
      alt: "verticals image",
    },
    mediaHover: {
      src: homeVerticalsImg3,
      alt: "verticals image",
    },
  },
  {
    id: "glamping",
    name: "Glamping",
    slug: "glamping",
    media: {
      src: homeVerticalsImg4,
      alt: "verticals image",
    },
    mediaHover: {
      src: homeVerticalsImg2,
      alt: "verticals image",
    },
  },
  {
    id: "design",
    name: "Design",
    slug: "design",
    media: {
      src: homeVerticalsImg5,
      alt: "verticals image",
    },
    mediaHover: {
      src: homeVerticalsImg1,
      alt: "verticals image",
    },
  },
];

/* --------------------------------------- */
/* ------------- WHY MODULAR ------------- */
/* --------------------------------------- */
// export const HOME_MODULAR_ITEMS = [
//   {
//     id: "sustainability",
//     title: "Sustainability",
//     description:
//       "At BMS we specialize in delivering high-quality, eco-friendly, sustaibanle construction projects.",
//     img: {
//       src: homeModularImg1,
//       alt: "Why modular image 1",
//     },
//   },
//   {
//     id: "speed",
//     title: "Speed",
//     description:
//       "Modular construction is the fastest method of building housing, capable of erecting a super-structure in weeks rather than months.",
//     img: {
//       src: homeModularImg2,
//       alt: "Why modular image 2",
//     },
//   },
//   {
//     id: "minimal-distruption",
//     title: "Minimal Disruption",
//     description:
//       "Our modular approach involves precision manufacturing of building modules in our factory, followed by transportation and on-site assembly, for minimal disruption",
//     img: {
//       src: homeModularImg3,
//       alt: "Why modular image 3",
//     },
//   },
// ];

export const HOME_MODULAR_ITEMS = [
  {
    id: "sustainability",
    title: "Sustainabillity Ensured",
  },
  {
    id: "construction",
    title: "Construction Speed",
  },
  {
    id: "Minimal",
    title: "Minimal Disruption",
  },
];

/* -------------------------------------- */
/* ------------- WHAT'S NEW ------------- */
/* -------------------------------------- */

/* ----------------------------------------- */
/* ------------- STATS NUMBERS ------------- */
/* ----------------------------------------- */
export const STAT_NUMBERS = [
  {
    id: crypto.randomUUID(),
    number: 81,
    description:
      "Successfully completed jobs over the time span of four years.",
    icon: <HandWithFlagSvg />,
  },
  {
    id: crypto.randomUUID(),
    number: 10,
    description:
      "The client success score awarded for our work across all platforms.",
    icon: <PlantSvg />,
  },
  {
    id: crypto.randomUUID(),
    number: 43,
    description:
      "Number of dedicated staff offering guidance through the process.",
    icon: <WomanSvg />,
  },
];

/* ----------------------------------------------- */
/* ------------- FOOTER SOCIAL MEDIA ------------- */
/* ----------------------------------------------- */
export const FOOTER_SOCIAL_MEDIA = [
  {
    id: "facebook",
    name: "Facebook",
    href: "https://www.facebook.com/bespokemodularsolutions",
  },
  {
    id: "instagram",
    name: "Instagram",
    href: "https://www.instagram.com/bespoke_modular_solutions/",
  },
  {
    id: "linkedin",
    name: "LinkedIn",
    href: "https://www.linkedin.com/company/bespoke-modular-solutions-company/",
  },
];
